var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"curTicker"},[_c('div',{staticClass:"tValue"},[_vm._v("1")]),_c('div',{staticClass:"tName"},[_vm._v(_vm._s(_vm.cur1))]),_c('span',[_vm._v("=")]),_c('div',{staticClass:"tValue"},[_vm._v(_vm._s(_vm.value2))]),_c('div',{staticClass:"tName"},[_vm._v(_vm._s(_vm.cur2))])])
}
var staticRenderFns = []

export { render, staticRenderFns }